/**
 * @voltxampere/ui — USB Type-C connector (Sprint 45-6, schema-only)
 *
 * Schema-only passthrough — engine'de davranış yok. 24-pin USB-C
 * simplified to USB 2.0 mode (D+ / D- / GND / VBUS). Reversible
 * orientation, USB-PD up to 100 W (Sprint 47+'da PD negotiation).
 *
 * Reference: Generic USB Type-C connector. VBUS 5-20 V @ 0.5-5 A
 * (PD profiles). Modern smartphone + laptop + USB hub standardı.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const connectorUsbC = {
    id: "usb-c",
    nameTr: "USB-C (Type-C 24-pin, schema-only)",
    nameEn: "USB-C (Type-C 24-pin, schema-only)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "J",
    defaultValue: "USB-C",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=connector-usb-c.js.map